export default __webpack_public_path__ + "static/media/sounds/vocab_fitb_practice_ready_instruction_alyx.mp3";